module.exports = __webpack_public_path__ + "static/img/p1_img2.a83a211.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p1_img2.png
// module id = VaAS
// module chunks = 0